import React, { useEffect, useState } from 'react';
import MetaTags from '@/components/meta/MetaTags';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const DropsSuccess: React.FC = () => {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [verified, setVerified] = useState<boolean | null>(null);

  useEffect(() => {
    const run = async () => {
      const collectionId = search.get('collectionId');
      const sessionId = search.get('sessionId') || search.get('session_id');
      if (!collectionId || !sessionId) {
        toast({ title: 'Missing info', description: 'Could not verify payment.' });
        return;
      }
      const { data, error } = await supabase.functions.invoke('verify-drop-payment', { body: { collectionId, sessionId } });
      if (error) {
        toast({ title: 'Verification failed', description: error.message });
        setVerified(false);
      } else {
        if (data?.paid) {
          toast({ title: 'Payment confirmed', description: 'Your drop was submitted for review.' });
          setVerified(true);
        } else {
          setVerified(false);
          toast({ title: 'Payment not completed', description: 'Session not marked as paid.' });
        }
      }
    };
    run();
  }, [search, toast]);

  return (
    <main className="container mx-auto max-w-2xl px-4 py-10 text-center">
      <MetaTags title="Drops – Payment Success" description="Your payment was processed. We are verifying it now." />
      <h1 className="text-2xl md:text-3xl font-bold mb-3">Payment Success</h1>
      <p className="text-muted-foreground mb-6">{verified === null ? 'Verifying your payment…' : verified ? 'All set! Your collection is now pending review.' : 'We could not confirm the payment.'}</p>
      <div className="flex gap-3 justify-center">
        <Button onClick={() => navigate('/drops')}>Create another</Button>
        <Button variant="secondary" onClick={() => navigate('/profile')}>Go to Profile</Button>
      </div>
    </main>
  );
};

export default DropsSuccess;
